import React from 'react'
import { RPCDocs } from '@therms/react-modules'
import { ItemRecordFields } from './ItemRecordFields'
import { PersonRecordFields } from './PersonRecordFields'
import { VehicleRecordFields } from './VehicleRecordFields'
import { RECORD_TYPES } from '@src/modules/Records/constants'

interface InfoTabProps {
  record: RPCDocs.Records.GetRecordProfile.v1.Record
}

function InfoTab({ record }: InfoTabProps) {
  if (record.type === RECORD_TYPES.ITEM) {
    return <ItemRecordFields record={record} />
  }

  if (record.type === RECORD_TYPES.PERSON) {
    return <PersonRecordFields record={record} />
  }

  if (record.type === RECORD_TYPES.VEHICLE) {
    return <VehicleRecordFields record={record} />
  }

  return null
}

export { InfoTab }
